import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { customToast } from 'core-lib/utils/customToast';

export const subscribeCarReview = async (payload) => {
  const url = `${apiConfig('chariot')}/v2/rating/subscribe`;
  const { response, error }: any = await postMethod({
    endPoint: url,
    body: payload,
  });

  if (response) {
    return response.status === 0;
  }
  if (error) {
    // customToast({
    //   label: error?.message || 'Something went wrong',
    //   variant: 'criticalNotPriority',
    // });
  }
  return false;
};
